import * as React from "react";
function ArrowNavUpIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.268 15.087a.9.9 0 0 0-.266-.642l-6.057-6.057A1.3 1.3 0 0 0 12 8c-.35-.008-.69.123-.945.364L4.998 14.42a.91.91 0 0 0 0 1.284.895.895 0 0 0 1.284 0L12 10.01l5.718 5.718a.897.897 0 0 0 1.284 0 .88.88 0 0 0 .266-.642"
  }));
}
export default ArrowNavUpIcon;